<template>
  <div class="intro-grid grid-x align-middle" :class="{'show' : showText}">
    <div class="cell small-12 large-6 large-offset-3">
      <p ref="text" class="h4">
        <span class="dinamo" />
        {{$t('intro.first')}}
        <router-link :to="{name: 'page', params: {page: $t('nav.chi.children.persone.slug')}}">team</router-link>
        {{$t('intro.second')}}
        <router-link :to="{name: 'page', params: {page: $t('nav.chi.children.competenze.slug')}}">{{$t('intro.competenze')}}</router-link>
        {{$t('intro.third')}}
        <router-link :to="{name: 'page', params: {page: $t('nav.come.children.marketing.slug')}}">marketing</router-link>,
        <router-link :to="{name: 'page', params: {page: $t('nav.come.children.building.slug')}}">{{$t('intro.tecnologia')}}</router-link>,
        <router-link :to="{name: 'page', params: {page: $t('nav.come.children.design.slug')}}">{{$t('intro.design')}}</router-link>,
        {{$t('intro.fourth')}}
        <router-link :to="'/' + $i18n.locale + '/'+ $t('nav.cosa.slug')">{{$t('intro.clienti')}}</router-link>.
      </p>
    </div>
  </div>
</template>

<script>
export default {
  name: "HomeIntro",
  props: {
    hasScrolled: {
      default: false
    }
  },
  data() {
    return {
      showText: false
    };
  },
  mounted() {
    setTimeout(() => {
      this.showText = true;
    }, 500);
  },
  watch: {
    hasScrolled(value) {
      if (value === true) {
        this.showText = false;
      }
    }
  }
};
</script>

<style lang="scss">
@import "@assets/scss/_importer.scss";
.intro-grid {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  z-index: 1;
  background: $white;
  min-height: 100vh;
  padding: 64px;
  @include breakpoint(medium down) {
    padding: 0 32px;
  }
  .cell {
    p {
      line-height: 36px;
      @include transform(translateY(10px));
      opacity: 0;
      @include transition-duration(1s);
      a {
        font-weight: $global-weight-bold;
        text-decoration: underline;
        &:hover {
          text-decoration: none;
        }
      }
      .dinamo {
        width: 109.92px;
        height: 23.05px;
        background-image: url("../assets/img/dinamo-word.svg");
        display: inline-block;
        background-size: cover;
        background-position: center;
        vertical-align: middle;
        position: relative;
        top: -3px;
      }
    }
  }
  &.show .cell p {
    @include transform(translateY(0));
    opacity: 1;
  }
}
</style>
